/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 */

'use strict';

class AccordionGroup {

    constructor($accordion_group) {
        this.$accordion_group = $accordion_group;
        $accordion_group.data('accordion-group', this);
        let accordion_group_id = $accordion_group.attr('id');
        let $accordion_buttons = accordion_group_id ? $('[data-accordion-group-id="'+accordion_group_id+'"][aria-controls]') : $();
        if(!$accordion_buttons.length){
            $accordion_buttons = $accordion_group.find('.accordion-button[aria-controls]');
        }
        this.allow_many = $accordion_group.hasClass('allow-accordion-many');
        this.hide_with_child_accordions = $accordion_group.hasClass('hide-with-child-accordions');

        let control_ids = [];
        $accordion_buttons.each((index, element) => {
            let $accordion_button = $(element);
            let control_id = $accordion_button.attr('aria-controls');
            let $content_element = control_id ? this.$accordion_group.find('#'+control_id) : $();
            if($content_element.length !== 1){
                $accordion_button.removeAttr("aria-controls");
                return;
            }
            if(!control_ids.includes(control_id)){
                control_ids.push(control_id);
            }
        });
        $accordion_buttons = $accordion_buttons.filter('[aria-controls]');
        this.$accordion_buttons = $accordion_buttons;
        this.control_ids = control_ids;

        let any_open = false;
        for(let i = 0; i < control_ids.length; i ++){
            let control_id = control_ids[i];
            let $control_buttons = $accordion_buttons.filter('[aria-controls="'+control_id+'"]');

            let is_expanded = false;
            $control_buttons.each((index, element) => {
                let $accordion_button = $(element);
                let aria_expanded = $accordion_button.attr('aria-expanded');
                if(aria_expanded && !(typeof aria_expanded === 'string' && aria_expanded.toLowerCase() === 'false')){
                    is_expanded = true;
                    any_open = true;
                }
            });
            $control_buttons.attr('aria-expanded', is_expanded ? 'true' : 'false');
        }
        $accordion_buttons.on('click', (event) => {
            event.preventDefault();
            this.toggle($(event.target).closest('[aria-controls]').attr('aria-controls'))
        });
        this.set_open(null, any_open);
    }

    toggle(control_id) {
        let $control_buttons = this.$accordion_buttons;
        if(control_id){
            $control_buttons = $control_buttons.filter('[aria-controls="'+control_id+'"]');
        }
        $control_buttons = $control_buttons.filter('[aria-expanded="true"]');
        let is_open = !!$control_buttons.length;
        this.set_open(control_id, !is_open)
    }

    set_open(control_id, do_open) {

        let any_open = false;
        for(let i = 0; i < this.control_ids.length; i ++) {
            let this_control_id = this.control_ids[i];
            let $control_buttons = this.$accordion_buttons.filter('[aria-controls="' + this_control_id + '"]');
            let $content_element = this.$accordion_group.find('#'+this_control_id);
            let this_do_open;
            if(!this.allow_many && any_open){
                this_do_open = false;
            } else if(!control_id || control_id === this_control_id){
                this_do_open = do_open;
            } else {
                if(!this.allow_many && do_open){
                    this_do_open = false;
                } else {
                    this_do_open = $control_buttons.attr('aria-expanded') === 'true';
                }
            }

            if(!this_do_open){
                $control_buttons.attr('aria-expanded', 'false');
                $content_element.attr("hidden", "");
                if(this.hide_with_child_accordions){
                    this.$accordion_group.find('.accordion-group').each((index, element) => {

                        let accordion_group = $(element).data('accordion-group');
                        if(accordion_group){
                            accordion_group.set_open(null, false);
                        }
                    })
                }
            } else {
                $control_buttons.attr('aria-expanded', 'true');
                $content_element.removeAttr("hidden");
                any_open = true;
            }
            let $accordion_group_item = $content_element.closest('.accordion-group-item');

            if(!this_do_open){
                $accordion_group_item.removeClass('accordion-group-item-open');
            } else {
                $accordion_group_item.addClass('accordion-group-item-open');
            }
        }
        if(!any_open){
            this.$accordion_group.removeClass('accordion-open');
        } else {
            this.$accordion_group.addClass('accordion-open');
        }
    }
}

$('.accordion-group').each((index, element) => {
    new AccordionGroup($(element));
})